import { SpaceFeature, SpaceInterface, SpacePickerParams } from "@swivl/swivl-lib";

export const imageAndTextURLForSpace = (space: SpaceInterface, params: SpacePickerParams) => {
  let imageURL = 'https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-small%402x.png'
  let text = params.sizeSmallDescription
  if (space.isParking) {
    imageURL = 'https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-parking%402x.png'
    text = params.sizeParkingDescription;

  } else if (space.width && space.length) {
    const sqft = space.width * space.length;
    if (sqft <= params.smallMaxSize) {
      imageURL = 'https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-small%402x.png'
      text = params.sizeSmallDescription;
    } else if (sqft > params.smallMaxSize && sqft <= params.mediumMaxSize) {
      imageURL = 'https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-medium%402x.png'
      text = params.sizeMediumDescription
    } else if (sqft > params.mediumMaxSize && sqft <= params.largeMaxSize) {
      imageURL = 'https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-large%402x.png'
      text = params.sizeLargeDescription
    } else if (sqft > params.largeMaxSize) {
      imageURL = 'https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-extra-large%402x.png'
      text = params.sizeExtraLargeDescription
    } else {


    }
  }

  if (space.features?.includes(SpaceFeature.COMMERCIAL_WAREHOUSE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-commercial-warehouse%402x.png"

  }
  if (space.features?.includes(SpaceFeature.LOCKER)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-locker%402x.png"
  }
  if (space.features?.includes(SpaceFeature.OFFICE_SPACE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-office-space%402x.png"
  }


  if (space.features?.includes(SpaceFeature.PARKING)) {
      text = params.sizeParkingDescription;

    if (space.features?.includes(SpaceFeature.COVERED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-car%402x.png"
    } else if (space.features?.includes(SpaceFeature.ENCLOSED)) {

      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-car%402x.png"
    } else {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-car%402x.png"
    }

  }

  if (space.features?.includes(SpaceFeature.RV_PARKING)) {
    if (space.features?.includes(SpaceFeature.COVERED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-rv%402x.png"
    } else if (space.features?.includes(SpaceFeature.ENCLOSED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-rv%402x.png"
    } else if (space.features?.includes(SpaceFeature.PAVED) && space.features?.includes(SpaceFeature.PULL_THRU)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-pullthru-paved-rv%402x.png"
    } else if (space.features?.includes(SpaceFeature.PAVED) && space.features?.includes(SpaceFeature.PULL_THRU)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-pullthru-unpaved-rv%402x.png"
    } else if (space.features?.includes(SpaceFeature.UNPAVED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-unpaved-rv%402x.png"
    } else if (space.features?.includes(SpaceFeature.PAVED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-paved-rv%402x.png"
    } else {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-rv%402x.png"
    }
  }

  if (space.features?.includes(SpaceFeature.BOAT_PARKING)) {
    if (space.features?.includes(SpaceFeature.COVERED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-boat%402x.png"
    } else if (space.features?.includes(SpaceFeature.ENCLOSED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-boat%402x.png"
    } else {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-boat%402x.png"
    }

  }

  if (space.features?.includes(SpaceFeature.SAFETY_DEPOSIT_BOX)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-security-deposit-box%402x.png"
  }
  if (space.features?.includes(SpaceFeature.WINE_STORAGE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-wine%402x.png"
  }
  if (space.features?.includes(SpaceFeature.GUN_STORAGE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-gun.png"
  }

  return { imageURL: imageURL, text: text }
}